import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
    

    var EXCLUDED_CALL_CONTROLS = [
        'RPAD' // considered a call control but we want to show JUST up/down status (UI-1152)
    ];

    function TopUtilizedGridFormatter(params, observableOptions) {
        var self = this;

        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();
        self.isBridge = (params && params.type === 'Bridge');
        self.isCallControl = (params && params.type === 'CallControl');
        self.observableFormattedData = ko.observable({});
        self.observableOptions = observableOptions;
        self.subscriptions = [];
    }

    TopUtilizedGridFormatter.prototype = {
        composeData: function (formatterCommon, gridFormatterCommon, sourceList) {
            var self = this;

            if (_.isEmpty(sourceList)) {
                return {
                    maxCount: 0,
                    rows: []
                };
            }

            var list = [];
            var finalList = [];
            sourceList.forEach(function (item) {
                if (item.status === 'OK') {
                    list.push({
                        type: item.type,
                        name: item.name,
                        LicenseUsage: parseFloat(item.LicenseUsage).toFixed(2),
                        status: item.status
                    });
                }
            });

            var sortedList = self.sortAndGetTop5(list);
            var getLicenseUsageMarkup = self.getLicenseUsageMarkup.bind(this);
            sortedList.forEach(function (item) {
                finalList.push({
                    icon: formatterCommon.getIcon(item.type),
                    title: formatterCommon.getSpanTitle(item.name),
                    usageMarkup: getLicenseUsageMarkup(formatterCommon, item.LicenseUsage)
                });
            });

            return {
                rows: finalList,
                rowProperties: ['icon', 'title', 'usageMarkup'],
                widths: ['15%', '70%', '15%']
            };
        },

        DataUpdated: function () {
            var self = this;
            self.RefreshData();
        },

        dispose: function () {
            var self = this;
            self.subscriptions.forEach(function (sub) {
                sub.dispose();
            });
        },

        getLicenseUsageMarkup: function (formatterCommon, value) {
            var backgroundColor = formatterCommon.getColorForPercentage(value);
            var markup;
            if (backgroundColor) {
                var formattedPercentage = Math.round(value * 100) + '%';
                markup = '<span title="' + formattedPercentage + '" style="color:' + backgroundColor + '">' + formattedPercentage + '</span>';
            } else {
                markup = '';
            }
            return markup;
        },

        getObservableData: function () {
            var self = this;
            return self.observableFormattedData;
        },

        initialize: function (dataRepository) {
            var self = this;

            self.dataRepository = dataRepository;

            if (self.isBridge) {
                self.sourceList = dataRepository.systemStatusDataAllBridges;

            } else if (self.isCallControl) {
                self.sourceList = dataRepository.systemStatusDataCallControls;
            }

            if (self.sourceList) {
                var dataUpdated = self.DataUpdated.bind(this);
                self.subscriptions.push(self.sourceList.subscribe(function () {
                    dataUpdated();
                }));
            }

            var optionsUpdated = self.OptionsUpdated.bind(this);
            self.subscriptions.push(self.observableOptions.subscribe(function () {
                optionsUpdated();
            }));

            // initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
            if (!_.isEmpty(self.sourceList())) {
                self.RefreshData();
            }
        },

        OptionsUpdated: function () {
            var self = this;
            self.RefreshData();
        },

        RefreshData: function () {
            var self = this;
            var composeData = self.composeData.bind(this);
            var sourceList = self.sourceList();

            if (self.isCallControl) {
                sourceList = _.filter(sourceList, function(item) {
                    return !_.includes(EXCLUDED_CALL_CONTROLS, _.toUpper(item.type));
                });
            }
            self.observableFormattedData(
                composeData(
                    self.formatterCommon,
                    self.gridFormatterCommon,
                    sourceList,
                    self.observableOptions()
                )
            );
        },

        sortAndGetTop5: function (list) {
            var filteredList = _.filter(list, function (item) {
                return _.isFinite(_.toNumber(_.get(item, 'LicenseUsage')));
            });
            return _.take(_.orderBy(filteredList, ['LicenseUsage', 'name'], ['desc', 'asc']), 5);
        }
    };

    export default TopUtilizedGridFormatter;
